import { useContext } from 'react'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { isStandardOccupancy } from 'lib/search/searchUtils'
import { shouldHideAccommodationSearchPrice } from 'lib/search/accommodationSearchPresentation'

export function useHideAnytimePrices(
  offerType?: App.OfferType,
  metadataHidePricing?: boolean,
  productType?: App.ProductType,
  filters?: App.OfferListFilters,
): boolean {
  const globalSearchState = useContext(GlobalSearchStateContext)

  return shouldHideAccommodationSearchPrice({
    offerType,
    productType,
    metadataHidePricing,
    hideAnytimePrices: !!globalSearchState?.hideAnytimePrices,
    hasStandardOccupancy: isStandardOccupancy(filters),
  })
}

export default useHideAnytimePrices
